import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *文案成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/jb`, { params })

/**
 *脚本列表
 * @param waId
 * 
*/

export const scenarioList = waId => Http.get(`${baseUrl}/sz/team/jb/${waId}`)
